import { useEffect, useState } from "react";

const RUN_ID = /^[A-Za-z0-9_-]{1,64}$/;

export default function CameraScheduleForm({ currentRun, currentInterval, onSubmit }) {
  const [runId, setRunId] = useState(currentRun || "");
  const [interval, setInterval] = useState(
    currentInterval ? Math.round(currentInterval / 60) : 60
  );
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (currentRun) setRunId(currentRun);
    if (currentInterval) setInterval(Math.round(currentInterval / 60));
  }, [currentInterval, currentRun]);

  const submit = async (event) => {
    event.preventDefault();
    setMessage("");
    const minutes = Number(interval);
    if (!RUN_ID.test(runId)) {
      setMessage("Use 1–64 letters, numbers, hyphens, or underscores.");
      return;
    }
    if (!Number.isInteger(minutes) || minutes < 15 || minutes > 720) {
      setMessage("Interval must be an integer from 15 to 720 minutes.");
      return;
    }
    setSubmitting(true);
    try {
      const result = await onSubmit(runId, minutes);
      setMessage(
        result.status === "sent"
          ? "Published to retained MQTT; waiting for the sleeping device."
          : "Saved, but MQTT publication failed. The device has not received this request."
      );
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-end">
        <label className="flex-1 text-sm font-semibold text-slate-700">
          Run ID
          <input
            value={runId}
            onChange={(event) => setRunId(event.target.value)}
            placeholder="water-level-001"
            className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 font-mono text-sm"
          />
        </label>
        <label className="text-sm font-semibold text-slate-700 sm:w-48">
          Shared interval (minutes)
          <input
            type="number"
            min="15"
            max="720"
            step="1"
            value={interval}
            onChange={(event) => setInterval(event.target.value)}
            className="mt-1 w-full rounded-xl border border-slate-200 px-3 py-2 text-sm"
          />
        </label>
        <button
          disabled={submitting}
          className="rounded-xl bg-blue-700 px-4 py-2.5 text-sm font-bold text-white disabled:opacity-50"
        >
          {submitting ? "Publishing…" : "Activate schedule"}
        </button>
      </div>
      <p className="mt-2 text-xs text-slate-500">
        This changes the single RTC interval shared by telemetry and scheduled imaging. It does not capture immediately.
      </p>
      {message && <p role="status" className="mt-2 text-sm text-slate-700">{message}</p>}
    </form>
  );
}
